import { Paper, Typography } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../components/withRouter";
import { dataNotFoundMsg, noInternetMsg } from "../../config/messageconstant";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { CompOffJson } from "../../DynamicFormsJson/Transaction/compOff";
import RTTable from "../../components/Comman/RT/RTTable";
import dayjs from "dayjs";
import endpoint from "../../config/endpoints";

class CompOffView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            detailsList: [],
        };
    }

    async componentDidMount() {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            if (this.props.params.id) {
                const startOfYear = dayjs().startOf("year").format("DD-MM-YYYY");
                showLoador({ loador: true });
                await apiGet({
                    url: endpoint.salesExecutive + "/comp-off-day-summary-by-sales-team-and-date?fromDate="
                        + startOfYear + "&toDate=" + dayjs().format("DD-MM-YYYY") + "&salesTeamId=" + this.props.params.id,
                }).then(({ data, success }) => {
                    if (!success) {
                    } else {

                        let rowList = data.data.map(
                            (dataObject, index) => {
                                let newList = {
                                    index: index + 1,
                                    id: dataObject.id !== null ? dataObject.id : "",
                                    date: dataObject.date !== null ? dataObject.date : "",
                                    dayName: dataObject.dayName !== null ? dataObject.dayName : "",
                                    attendence: dataObject.attendence !== null ? dataObject.attendence : "",
                                    attendanceStatus:
                                        dataObject.attendence !== null ?
                                            dataObject.attendence == 0 ? "Present" :
                                                dataObject.attendence == 1 ? "Absent" :
                                                    dataObject.attendence == 2 ? "Holiday" :
                                                        dataObject.attendence == 3 ? "Weekly Off" :
                                                            dataObject.attendence == 4 ? "Leave" :
                                                                dataObject.attendence == 5 ? "Present + Holiday" :
                                                                    dataObject.attendence == 6 ? "Present + Weekly Off" :
                                                                        dataObject.attendence == 7 ? "Present + Weekly Off + Holiday" :
                                                                            "Present + Leave" : "",
                                    isCompOffApplicable: dataObject.isCompOffApplicable !== null ? dataObject.isCompOffApplicable == 1 ? "Yes" : "No" : "",
                                };
                                return newList;
                            }
                        );
                        this.setState({
                            detailsList: rowList,
                        });


                        if (rowList.length == 0) {
                            return showNotification({ msg: dataNotFoundMsg, severity: "error" });
                        }
                    }
                });
                showLoador({ loador: false });
            }
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }
    render() {
        const { dynamicMasterData, detailsList } =
            this.state;

        const columns = [
            { title: "Sr.No.", name: "index", align: "center" },
            { title: "Date", name: "date" },
            { title: "Day", name: "dayName", align: "left" },
            { title: "Attendance Status", name: "attendanceStatus", align: "left" },
        ];
        return (
            <>
                <Paper
                    sx={{
                        p: 2,
                        borderRadius: 0,
                    }}
                    elevation={0}
                >
                    <DynamicFormWithoutSave
                        showBackToList={true}
                        dynamicMasterData={dynamicMasterData}
                        showTitle={true}
                        screenTitle={"Comp Off Details"}
                        fieldMeta={[]}
                        apiBaseURL={CompOffJson.apiBaseURL}
                        showSaveNextBtn={[]}
                        saveBtnText={"Search"}
                        showSaveBtnMain={false}
                    />

                    <Typography color="error" fontWeight={400} sx={{ mb: 1 }}>
                        Note : Here we show only those records which are marked as comp off.
                    </Typography>

                    <RTTable
                        columns={columns}
                        tableData={detailsList}
                        isActionColActive={false}
                        showPegination={false}
                    />
                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    showNotification,
    showLoador,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(CompOffView);
